// import React, { useState, Component } from "react";
// export default class AddUser extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {};
//   }

//   render() {
//     return <div>add user</div>;
//   }
// }
import React, { Component } from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  Divider,
  Switch,
  TextField,
  Typography,
  colors
} from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import Paper from "@material-ui/core/Paper";
import ChipInput from "material-ui-chip-input";
import Autocomplete from "@material-ui/lab/Autocomplete";
import axios from "axios";
import { toast } from "react-toastify";
import useAutocomplete from "@material-ui/lab/useAutocomplete";
import NoSsr from "@material-ui/core/NoSsr";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import styled from "styled-components";
import { Multiselect } from "multiselect-react-dropdown";
import _apiData from "../../metaData";
import "./userAction.css";

let apiData = _apiData[0];

let workOrder = localStorage.getItem("workOrderObj");
if (workOrder) {
  workOrder = JSON.parse(workOrder);
}
let work_order;
if (workOrder) {
  work_order = workOrder.workOrder;
}

let top100Films = [
  { title: "" },
  { title: "venu" },
  { title: "gopal" },
  { title: "venu1" },
  { title: "gopal1" },
  { title: "venu2" },
  { title: "gopal2" },
  { title: "venu3" },
  { title: "gopal3" }
];
let self;
let selectedProjectsNew = [];
let selectedAppsNew = [];

let loginDetails = localStorage.getItem("loginDetails");
if (loginDetails) {
  loginDetails = JSON.parse(loginDetails);
}

const Label = styled("label")`
  padding: 0 0 4px;
  line-height: 1.5;
  display: block;
`;

const InputWrapper = styled("div")`
  width: 300px;
  border: 1px solid #d9d9d9;
  background-color: #fff;
  border-radius: 4px;
  padding: 1px;
  display: flex;
  flex-wrap: wrap;

  &:hover {
    border-color: #40a9ff;
  }

  &.focused {
    border-color: #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  & input {
    font-size: 14px;
    height: 30px;
    box-sizing: border-box;
    padding: 4px 6px;
    width: 0;
    min-width: 30px;
    flex-grow: 1;
    border: 0;
    margin: 0;
    outline: 0;
  }
`;

const Tag = styled(({ label, onDelete, ...props }) => (
  <div {...props}>
    <span>{label}</span>
    <CloseIcon onClick={onDelete} />
  </div>
))`
  display: flex;
  align-items: center;
  height: 24px;
  margin: 2px;
  line-height: 22px;
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 2px;
  box-sizing: content-box;
  padding: 0 4px 0 10px;
  outline: 0;
  overflow: hidden;

  &:focus {
    border-color: #40a9ff;
    background-color: #e6f7ff;
  }

  & span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  & svg {
    font-size: 12px;
    cursor: pointer;
    padding: 4px;
  }
`;

const Listbox = styled("ul")`
  width: 300px;
  margin: 2px 0 0;
  padding: 0;
  position: absolute;
  list-style: none;
  background-color: #fff;
  overflow: auto;
  max-height: 250px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 1;

  & li {
    padding: 5px 12px;
    display: flex;

    & span {
      flex-grow: 1;
    }

    & svg {
      color: transparent;
    }
  }

  & li[aria-selected="true"] {
    background-color: #fafafa;
    font-weight: 600;

    & svg {
      color: #1890ff;
    }
  }

  & li[data-focus="true"] {
    background-color: #e6f7ff;
    cursor: pointer;

    & svg {
      color: #000;
    }
  }
`;

class AddClients extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datasource: ["venu", "gopal"],
      fixedOptions: [top100Films[0]],
      workorderObjects: [],
      agentRole: "",
      selectedClient: "",
      selectedProjects: [],
      selectedApps: [],
      clientsList: [],
      projectsList: [],
      selectedProjects: [],
      appsList: [],
      clientName: "",
      email: "",
      firstName: "",
      lastName: "",
      password: "",
      mobile: "",
      reEnterPassword: "",
      options: [{ label: "venu" }, { label: "gopal" }]
    };
    this.handleDataChange = this.handleDataChange.bind(this);
    this.callGetClientssApi = this.callGetClientssApi.bind(this);
    this.callGetProjectsApi = this.callGetProjectsApi.bind(this);
    this.getAppsList = this.getAppsList.bind(this);
    self = this;
  }

  componentDidMount() {
    // axios
    //   .get(apiData.getAllWorkorders.url, {
    //     params: {},
    //     headers: apiData.headers
    //   })
    //   .then(res => {
    //     if (res.data.status) {
    //       console.log(res.data.response.WorkOrderObjs, "resss");
    //       let response = res.data.response.WorkOrderObjs;
    //       response.map((ele, index) => {
    //         if (ele.workOrder == "AP1") {
    //           response.splice(index, 1);
    //         }
    //       });
    //       this.setState({
    //         workorderObjects: response
    //       });
    //     } else {
    //     }
    //   });
    axios
      .get(apiData.workorder_projects.url, {
        params: {
          work_order: apiData.workorder_projects.params.work_order
        },
        headers: apiData.headers
      })
      .then(res => {
        if(res.data.status) {
          let ulbObj = res.data.response.ulbList.map(item => {
            return {
              name : item
            }
          })
          this.setState({projectsList: ulbObj})
        }
      })

    // this.getAppsList();
    // this.callGetClientssApi(workOrder);
  }

  handleDataChange(data) {
    console.log(data, "datadata");
    // data = { naame: 'name', label: 'label' }
  }
  getAppsList() {
    axios
      .get(apiData.getAppsList.url, {
        params: {},
        headers: apiData.headers
      })
      .then(res => {
        console.log(res, "res appslist");
        if (res.data.status) {
          let response = res.data.response.appList;
          let responseArray = [];
          response.map(ele => {
            let obj = {};
            obj.title = ele;
            responseArray.push(obj);
          });
          this.setState({
            appsList: responseArray
          });
        }
      });
  }

  chipValues(event, newValue) {
    this.setState({
      value: [
        ...this.state.fixedOptions,
        ...newValue.filter(
          option => this.state.fixedOptions.indexOf(option) === -1
        )
      ]
    });
  }

  selectWorkorder(e) {
    document.querySelectorAll(".MuiChip-root").forEach(function(a) {
      a.remove();
    });
    this.setState({
      selectedWorkorder: e.target.value,
      clientsList: [],
      projectsList: [{ title: "" }],
      selectedClient: "",
      selectedProjects: [],
      selectedApps: []
      // value: "",
      // projects: [{ title: "" }]
    });
    if (e.target.value) {
      this.callGetClientssApi(e.target.value);
    }
  }

  callGetClientssApi(workOrder) {
    if (workOrder.workOrder) {
      workOrder = workOrder.workOrder;
    } else {
      workOrder = workOrder;
    }
    if (workOrder) {
      this.setState({
        selectedWorkorder: workOrder
      });
      console.log(workOrder, "workOrder sele--");
      axios
        .get(apiData.getWorkorderClients.url, {
          params: { work_order: workOrder },
          headers: apiData.headers
        })
        .then(res => {
          if (res.data.status) {
            let response = res.data.response.Clients;
            console.log(response, "responseresponse");
            this.setState({
              clientsList: response
            });
          } else {
            toast.error(
              res.data.response.reason
                ? res.data.response.reason
                : "No Clients!",
              {
                position: toast.POSITION.TOP_RIGHT
              }
            );
          }
        });
    }
  }

  callGetProjectsApi(client) {
    if (client) {
      console.log(client, "clientclient");
      let params = {};
      params.work_order = this.state.selectedWorkorder;
      params.client_id = client;
      axios
        .get(apiData.getClientProjects.url, {
          params: params,
          headers: apiData.headers
        })
        .then(res => {
          if (res.data.status) {
            console.log(res.data.response.ulbList, "ress clientProjjj");
            let response = res.data.response.ulbList;
            let responseArray = [];
            response.map(ele => {
              let obj = {};
              obj.title = ele;
              responseArray.push(obj);
            });
            this.setState({
              projectsList: responseArray
            });
          } else {
            toast.error(
              res.data.response.reason
                ? res.data.response.reason
                : "No Projects!",
              {
                position: toast.POSITION.TOP_RIGHT
              }
            );
          }
        });
    } else {
      toast.error("No Client Id!", {
        position: toast.POSITION.TOP_RIGHT
      });
    }
  }

  submitAgent(e) {
    e.preventDefault();
    let projectsArray = this.state.selectedProjects.map(item => Object.values(item));
    var mergedProjectsArray = [].concat.apply([], projectsArray);

    axios.post(apiData.add_client.url,{
      work_order: apiData.add_client.params.work_order,
      superClientId: JSON.parse(localStorage.getItem("loginDetails")).user.clientId,
      ulbs: mergedProjectsArray,
      client_name: this.state.clientName,
      email: this.state.email,
      mobile_number: this.state.mobile,
      password: this.state.password
    },{
      headers: apiData.headers
    })
    .then(res => {
      if(res.data.ok){
        toast.success("Client Added Sucessfully", {
          position: toast.POSITION.TOP_RIGHT
        });
        this.setState({
          selectedProjects: [],
          clientName: "",
          email: "",
          mobile: "",
          password: "",
          reEnterPassword: ""
        })
      } else {
        console.log(res)
      }
    })
    // document.querySelectorAll(".sc-dlnjPT").forEach(function(a) {
    // // document.querySelectorAll(".fUJvAw").forEach(function(a) {
    //   // a.style.visibility = "hidden";
    //   a.style.display = "none";
    //   // a.remove();
    // });

    // this.setState({
    //   selectedProjects: selectedProjectsNew
    // });
    // let selectedProjects = selectedProjectsNew;
    // // let selectedProjects = this.state.selectedProjects;
    // let selectedProjectsArray = [];
    // selectedProjects.map(ele => {
    //   if (ele.title) {
    //     selectedProjectsArray.push(ele.title);
    //   }
    // });

    // this.setState({
    //   selectedApps: selectedAppsNew
    // });
    // let selecteApps = [...selectedAppsNew];
    // // let selecteApps = this.state.selectedApps;
    // let selecteAppsArray = [];
    // selecteApps.map(ele => {
    //   if (ele.title) {
    //     selecteAppsArray.push(ele.title);
    //   }
    // });
    // console.log(selecteAppsArray, "selecteAppsArrayvv");
    // console.log(selecteApps, "selecteAppsvv");

    // function _isPhone(phone) {
    //   var regex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
    //   return regex.test(phone);
    // }

    // if (!this.state.selectedWorkorder) {
    //   toast.error("Please Select Workorder", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // }
    // //  else if (!this.state.selectedClient) {
    // //   toast.error("Please Select Client", {
    // //     position: toast.POSITION.TOP_RIGHT
    // //   });
    // // } else if (!selectedProjectsArray.length) {
    // //   toast.error("Please Select Projects", {
    // //     position: toast.POSITION.TOP_RIGHT
    // //   });
    // // }
    // else if (!selecteAppsArray.length) {
    //   toast.error("Please Select Apps", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // } else if (!this.state.firstName) {
    //   toast.error("Please Enter First Name", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // } else if (!this.state.lastName) {
    //   toast.error("Please Enter Last Name", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // } else if (!this.state.agentRole) {
    //   toast.error("Please Select Agent Role", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // } else if (!this.state.mobile) {
    //   toast.error("Please Enter Mobile Number", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // } else if (!_isPhone(this.state.mobile)) {
    //   toast.error("Please Enter Valid Mobile Number", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // } else if (!this.state.password) {
    //   toast.error("Please Enter Password", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // } else if (this.state.password.length < 6) {
    //   toast.error("Minimum Length of Password is 6 Letters", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // } else if (!this.state.reEnterPassword) {
    //   toast.error("Please Enter Confirm Password", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // } else if (this.state.password !== this.state.reEnterPassword) {
    //   toast.error("Password and Re-enter password Must be the Same!", {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    // } else {
    //   // let selectedUlbs = selectedProjectsNew;
    //   let selectedUlbs = [];
    //   // this.state.selectedProjects.map(ele => {
    //   selectedProjectsNew.map(ele => {
    //     if (ele.title) {
    //       selectedUlbs.push(ele.title);
    //     }
    //   });

    //   let selectedApps = [];
    //   // this.state.selectedApps.map(ele => {
    //   selectedAppsNew.map(ele => {
    //     if (ele.title) {
    //       selectedApps.push(ele.title);
    //     }
    //   });
    //   console.log(selectedApps, selectedUlbs, "selectedUlbshhyy");

    //   let data = {};
    //   data.work_order = this.state.selectedWorkorder;
    //   // data.client_id = this.state.selectedClient;
    //   data.mobile_number = this.state.mobile;
    //   data.password = this.state.password;
    //   data.first_name = this.state.firstName;
    //   data.last_name = this.state.lastName;
    //   data.user_type = this.state.agentRole;
    //   // data.ulbs = selectedUlbs;
    //   data.apps = selectedApps;
    //   data.created_by_username = loginDetails.user
    //     ? loginDetails.user.username
    //     : "";
    //   console.log(data, "dataadataa");
    //   axios
    //     .post(apiData.agentDetails.url, data, {
    //       headers: apiData.headers
    //     })
    //     .then(res => {
    //       console.log(res, "resss post agent");
    //       if (res.data.ok) {
    //         toast.success("Agent Added Sucessfully", {
    //           position: toast.POSITION.TOP_RIGHT
    //         });
    //         document.getElementById("dataForm").reset();
    //         document.querySelectorAll(".sc-dlnjPT").forEach(function(a) {
    //           a.style.display = "none";
    //           // a.remove();
    //         });
    //         // this.callGetClientssApi(workOrder);
    //         this.setState(
    //           {
    //             // selectedWorkorder: "",
    //             selectedClient: "",
    //             selectedProjects: [],
    //             selectedApps: [],
    //             firstName: "",
    //             lastName: "",
    //             agentRole: "",
    //             mobile: "",
    //             password: "",
    //             reEnterPassword: "",
    //             // clientsList: [],
    //             projectsList: [{ title: "" }],
    //             selectedProjects: [],
    //             selectedApps: [],
    //             appsList: []
    //           },
    //           () => {
    //             this.getAppsList();
    //           }
    //         );
    //         selecteAppsArray = [];
    //         selectedAppsNew = [];
    //         selecteApps = [];
    //         console.log(
    //           selecteApps,
    //           selecteAppsArray,
    //           selectedAppsNew,
    //           "pppooooo"
    //         );
    //       } else {
    //         toast.error(
    //           res.data.error.reason ? res.data.error.reason : "Error!",
    //           {
    //             position: toast.POSITION.TOP_RIGHT
    //           }
    //         );
    //       }
    //     });
    // }
  }
  projectsChange(e) {
    console.log(e.target.value, "selprooj");
  }

  render() {
    console.log(selectedProjectsNew, "rendr state");
    return (
      <div className="container hole-container" style={{ width: "76em" }}>
        <h6 className="page-header">Add Client</h6>
        <form className="form-style" id="dataForm">

          <div className="row data-row">
            <div className="col-md-2 label-class">
              <span className="label-text">Projects</span>
            </div>
            <div className="col-md-10 select-bordered-div">
              <Grid item md={12} xs={12}>
                <Multiselect 
                  style={{
                    searchBox: {
                      height: "55px",
                      fontSize: "16px"
                    },
                    chips: { // To change css chips(Selected options)
                      background: "#e8796a"
                    },
                  }}
                  options={this.state.projectsList} 
                  onSelect={(items) => this.setState({selectedProjects: items})} 
                  onRemove={(items) => this.setState({selectedProjects: items})} 
                  displayValue="name" 
                  showCheckbox={true}
                  selectedValues={this.state.selectedProjects}
                  />
              </Grid>
            </div>
          </div>

          <div className="row data-row">
            <div className="col-md-2 label-class">
              <span className="label-text">Client Name</span>
            </div>
            <div className="col-md-10 select-bordered-div">
              <Grid item md={12} xs={12}>
                <TextField
                  fullWidth
                  // label="Select State"
                  name="state"
                  label="Client Name"
                  onChange={e => {
                    this.setState({ clientName: e.target.value });
                  }}
                  // select
                  // eslint-disable-next-line react/jsx-sort-props
                  // SelectProps={{ native: true }}
                  value={this.state.clientName}
                  variant="outlined"
                ></TextField>
              </Grid>
            </div>
          </div>

          <div className="row data-row">
            <div className="col-md-2 label-class">
              <span className="label-text">Mobile Number</span>
            </div>
            <div className="col-md-10 select-bordered-div">
              <Grid item md={12} xs={12}>
                <TextField
                  fullWidth
                  // label="Select State"
                  name="state"
                  label="Mobile Number"
                  onChange={e => {
                    this.setState({ mobile: e.target.value });
                  }}
                  // select
                  // eslint-disable-next-line react/jsx-sort-props
                  // SelectProps={{ native: true }}
                  value={this.state.mobile}
                  variant="outlined"
                ></TextField>
              </Grid>
            </div>
          </div>

          <div className="row data-row">
            <div className="col-md-2 label-class">
              <span className="label-text">Email</span>
            </div>
            <div className="col-md-10 select-bordered-div">
              <Grid item md={12} xs={12}>
                <TextField
                  fullWidth
                  // type="number"
                  // label="Select State"
                  name="state"
                  label="Email"
                  onChange={e => {
                    this.setState({ email: e.target.value });
                  }}
                  // select
                  // eslint-disable-next-line react/jsx-sort-props
                  // SelectProps={{ native: true }}
                  value={this.state.email}
                  variant="outlined"
                ></TextField>
              </Grid>
            </div>
          </div>

          <div className="row data-row">
            <div className="col-md-2 label-class">
              <span className="label-text">Password</span>
            </div>
            <div className="col-md-10 select-bordered-div">
              <Grid item md={12} xs={12}>
                <TextField
                  fullWidth
                  name="state"
                  label="Password"
                  type="password"
                  onChange={e => {
                    this.setState({ password: e.target.value });
                  }}
                  variant="outlined"
                  value={this.state.password}
                ></TextField>
              </Grid>
            </div>
          </div>

          <div className="row data-row">
            <div className="col-md-2 label-class" style={{ padding: "0px" }}>
              <span className="label-text">Re-enter Password</span>
            </div>
            <div className="col-md-10 select-bordered-div">
              <Grid item md={12} xs={12}>
                <TextField
                  fullWidth
                  // label="Select State"
                  name="state"
                  label="Re-enter Password"
                  type="password"
                  onChange={e => {
                    this.setState({
                      reEnterPassword: e.target.value
                    });
                  }}
                  // select
                  // eslint-disable-next-line react/jsx-sort-props
                  // SelectProps={{ native: true }}
                  value={this.state.reEnterPassword}
                  variant="outlined"
                ></TextField>
              </Grid>
            </div>
          </div>

          <br />
          <div className="row">
            <div className="col-md-10"></div>
            <div className="col-md-2">
              <Button
                variant="contained"
                color="primary"
                component="span"
                onClick={this.submitAgent.bind(this)}
              >
                Submit
              </Button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export function CustomizedHook() {
  const {
    getRootProps,
    getInputLabelProps,
    getInputProps,
    getTagProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    value,
    focused,
    setAnchorEl
  } = useAutocomplete({
    id: "customized-hook-demo",
    // defaultValue: [top100Films[1]],
    multiple: true,
    options: self.state.projectsList,
    getOptionLabel: option => option.title
  });
  console.log(value, "valueoo");
  console.log(focused, "focusedoo");
  selectedProjectsNew = [...value];
  // self.setState({
  //   selectedProjects: value
  // });

  return (
    <NoSsr>
      <div>
        <div {...getRootProps()}>
          {/* <Label {...getInputLabelProps()}>Customized hook</Label> */}
          <InputWrapper
            ref={setAnchorEl}
            className={focused ? "focused" : ""}
            style={{ width: "100%", height: "3em" }}
          >
            {selectedProjectsNew.map((option, index) => (
              <Tag label={option.title} {...getTagProps({ index })} />
            ))}

            <input {...getInputProps()} />
          </InputWrapper>
        </div>
        {groupedOptions.length > 0 ? (
          <Listbox {...getListboxProps()} style={{ "z-index": "2" }}>
            {groupedOptions.map((option, index) => (
              <li {...getOptionProps({ option, index })}>
                <span>{option.title}</span>
                <CheckIcon fontSize="small" />
              </li>
            ))}
          </Listbox>
        ) : null}
      </div>
    </NoSsr>
  );
}

export function AppsHook() {
  const {
    getRootProps,
    getInputLabelProps,
    getInputProps,
    getTagProps,
    getListboxProps,
    getOptionProps,
    groupedOptions,
    value,
    focused,
    setAnchorEl
  } = useAutocomplete({
    id: "customized-hook-demo",
    // defaultValue: [top100Films[1]],
    multiple: true,
    options: self.state.appsList,
    getOptionLabel: option => option.title
  });
  console.log(value, "valueoo apps");
  console.log(focused, "focusedoo");
  selectedAppsNew = [...value];

  return (
    <NoSsr>
      <div>
        <div {...getRootProps()}>
          {/* <Label {...getInputLabelProps()}>Customized hook</Label> */}
          <InputWrapper
            ref={setAnchorEl}
            className={focused ? "focused" : ""}
            style={{ width: "100%", height: "3em" }}
          >
            {value.map((option, index) => (
              <Tag label={option.title} {...getTagProps({ index })} />
            ))}

            <input {...getInputProps()} />
          </InputWrapper>
        </div>
        {groupedOptions.length > 0 ? (
          <Listbox {...getListboxProps()} style={{ "z-index": "2" }}>
            {groupedOptions.map((option, index) => (
              <li {...getOptionProps({ option, index })}>
                <span>{option.title}</span>
                <CheckIcon fontSize="small" />
              </li>
            ))}
          </Listbox>
        ) : null}
      </div>
    </NoSsr>
  );
}

export default AddClients;
